// extracted by mini-css-extract-plugin
export default {"firstLayer":"Layout_firstLayer__1HUln"};